import React from 'react';
import { useNavigate } from 'react-router-dom';

const HEADINGS = {
  auth: 'Session expired',
  timeout: 'Taking longer than usual',
  network: 'Connection trouble',
};

/**
 * Error state shown by ReviewOrderPage when the order can't be loaded.
 *
 * Props:
 *   - fetchError: { kind: 'auth'|'timeout'|'network'|'not-found', message }
 *   - onRetry: bumps the retry tick on the parent
 *
 * Auth errors get a "Sign in" CTA; everything else gets "Retry". Both
 * paths surface a "Back to Dashboard" fallback.
 */
export const ReviewOrderError = ({ fetchError, onRetry }) => {
  const navigate = useNavigate();
  const err = fetchError || { kind: 'not-found', message: 'We could not load this order.' };
  const heading = HEADINGS[err.kind] || 'Order not found';

  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      data-testid="review-order-error"
    >
      <div className="max-w-md w-full bg-white border border-gray-200 rounded-xl shadow-sm p-8 text-center">
        <div className="text-2xl font-semibold text-[#2F5D3A] mb-2">{heading}</div>
        <p className="text-sm text-gray-600 mb-5">{err.message}</p>
        <div className="flex flex-col gap-2">
          {err.kind === 'auth' ? (
            <button
              onClick={() => navigate('/login')}
              data-testid="review-order-signin-btn"
              className="w-full bg-[#4A7C59] hover:bg-[#3D6A4A] text-white py-2.5 rounded-md font-medium"
            >
              Sign in
            </button>
          ) : (
            <button
              onClick={onRetry}
              data-testid="review-order-retry-btn"
              className="w-full bg-[#4A7C59] hover:bg-[#3D6A4A] text-white py-2.5 rounded-md font-medium"
            >
              Retry
            </button>
          )}
          <button
            onClick={() => navigate('/dashboard')}
            data-testid="review-order-dashboard-btn"
            className="w-full border border-[#4A7C59]/40 text-[#4A7C59] hover:bg-green-50 py-2.5 rounded-md font-medium"
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewOrderError;
